// extracted by mini-css-extract-plugin
export default {"graphWrapper":"styles_graph-wrapper__sq8NE","graph":"styles_graph__25XE7","halfDonut":"styles_half-donut__wMx89"};